import axios from "axios";
import { config } from "../config";

export interface Category {
  id: number;
  name: string;
  slug: string;
}

export async function getCategories(): Promise<Category[]> {
  try {
    const response = await axios.get(`${config.api.baseUrl}/categories`);
    return response.data.categories || [];
  } catch (error) {
    console.error("Помилка отримання категорій:", error);
    return [];
  }
}

export async function createCategory(categoryData: {
  name: string;
  description?: string;
  is_active: boolean;
}): Promise<Category> {
  try {
    const token = localStorage.getItem(config.auth.tokenKey);
    const response = await axios.post(
      `${config.api.baseUrl}/categories`,
      categoryData,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Помилка створення категорії:", error);
    throw error;
  }
}

export async function updateCategory(
  id: number,
  categoryData: Partial<Category>
): Promise<Category> {
  try {
    const token = localStorage.getItem(config.auth.tokenKey);
    const response = await axios.put(
      `${config.api.baseUrl}/categories/${id}`,
      categoryData,
      {
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Помилка оновлення категорії:", error);
    throw error;
  }
}
